// Договор-оферта на сайте компании (та же ссылка, что в чекбоксе регистрации)
export const OFFER_URL =
  'https://ambar-sklad.ru/%d0%b4%d0%be%d0%b3%d0%be%d0%b2%d0%be%d1%80-%d0%be%d1%84%d0%b5%d1%80%d1%82%d0%b0/';

// Стиль ссылки в текстах-пояснениях (цвет как у ссылки «оферты» при регистрации)
export const OFFER_LINK_STYLE = { color: '#466F8C', textDecoration: 'underline' };
